import { EstablecimientoEntry } from 'src/app/shared/entrys/establecimiento.entry';
import { Component, OnInit } from '@angular/core';
import { CapacidadTecnicaEntry } from 'src/app/shared/entrys/capacidad-tecnica.entry';
import { CapacidadOperativaEntry } from 'src/app/shared/entrys/capacidad-operativa.entry';
import { DetalleCapacidadService } from './capacidad-funcionario.service';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { Subscription } from 'rxjs';
import { DetalleEstablecimientoService } from '../establecimiento/establecimiento.service';
import { RolesUsuario } from 'src/app/shared/enumeraciones/roles-usuario.enum';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
	selector: 'app-capacidad-funcionario',
	templateUrl: './capacidad-funcionario.component.html',
	styleUrls: ['./capacidad-funcionario.component.scss']
})
export class CapacidadFuncionarioComponent implements OnInit {

	headersCapacidadTecnica: Array<string>;
	headersCapacidadOperativa: Array<string>;
	capacidadesTecnicas: Array<CapacidadTecnicaEntry> = [];
	capacidadesOperativas: Array<CapacidadOperativaEntry> = [];
	capacidadesTecnicas_anterior: Array<CapacidadTecnicaEntry> = [];
	capacidadesOperativas_anterior: Array<CapacidadOperativaEntry> = [];
	datoSolicitudSharedModel: DatoSolicitudSharedModel;
	suscripcion: Subscription;
	informacionEstablecimiento: any;
  informacionEstablecimientoAnterior: Array<EstablecimientoEntry> = [];
  informacionEstablecimientoActual: Array<EstablecimientoEntry> = [];
	tipo_prestador = RolesUsuario.Prestador;
  backgroundActual: string = 'versionActual';
  backgroundAnterior: string = 'versionAnterior';

	constructor(private detalleCapacidadService: DetalleCapacidadService, private dataSharedService: DataSharedService,
		private detalleEstablecimientoService: DetalleEstablecimientoService, public authService: AuthService) {
		this.suscripcion = this.dataSharedService.data$.subscribe(dataShared => {
			this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
		});
		this.informacionEstablecimiento = {};
	}

	ngOnInit() {
		this.capacidadesTecnicas = [] as Array<CapacidadTecnicaEntry>;
		this.capacidadesOperativas = [] as Array<CapacidadOperativaEntry>;
		this.headersCapacidadTecnica = ['Elemento', 'Descripción', 'Cantidad', 'Subtipo'];
		this.headersCapacidadOperativa = ['Formación de empleados', 'Número de empleados'];

		this.detalleCapacidadService.getCapacidadTecnica(this.datoSolicitudSharedModel.data).subscribe(res => {
			if (res.data) {
				res.data.forEach(respuesta => {
					if (respuesta.flag === 'Actual') {
						this.capacidadesTecnicas.push(respuesta);
					} else {
						this.capacidadesTecnicas_anterior.push(respuesta);
					}
				});

        this.getDifferencesCapacidad('capacidadTecnica');
			}
		});

		this.detalleCapacidadService.getCapacidadOperativa(this.datoSolicitudSharedModel.data).subscribe(res => {
			if (res.data) {
				res.data.forEach(respuesta => {
					if (respuesta.flag === 'Actual') {
						this.capacidadesOperativas.push(respuesta);
					} else {
						this.capacidadesOperativas_anterior.push(respuesta);
					}
				});

        this.getDifferencesCapacidad('capacidadOperativa');
			}
		});

		this.detalleEstablecimientoService.getDetalleEstablecimiento(this.datoSolicitudSharedModel.data).subscribe(res => {
			if (res.result) {
				this.informacionEstablecimiento = res.data;
			}
		});

    this.historicoSubCategoria();
	}

  historicoSubCategoria(){

    this.detalleEstablecimientoService.infoEstablecimientoHistorico.forEach( respuesta => {
      if (respuesta.flag === 'Actual') {
        this.informacionEstablecimientoActual.push(respuesta);
      } else {
        this.informacionEstablecimientoAnterior.push(respuesta);
      }
    });
  }

  getDifferencesCapacidad(option) {
    if (option === "capacidadTecnica") {
      // Capacidad Tencica
	    // Ediciones
      for (let i = 0; i < this.capacidadesTecnicas.length; i++) {
        let tempActual = this.capacidadesTecnicas[i];
        let tempAnterior = this.capacidadesTecnicas_anterior.find(
          (element) => element.id_relacion === tempActual.id_relacion
        );
        let indextempAnterior = this.capacidadesTecnicas_anterior.findIndex(
          (element) => {
            return element.id_relacion === tempActual.id_relacion;
          }
        );

        if(tempActual === undefined || tempAnterior === undefined){
          if(tempActual === undefined){
            this.capacidadesTecnicas_anterior[indextempAnterior].backColorDescripcion = this.backgroundAnterior;
            this.capacidadesTecnicas_anterior[indextempAnterior].backColorCantidad = this.backgroundAnterior;
          } else if(tempAnterior === undefined){
            this.capacidadesTecnicas[i].backColorDescripcion = this.backgroundActual;
            this.capacidadesTecnicas[i].backColorCantidad = this.backgroundActual;
          }
        } else{
          // Varificacion DESCRIPCION
          if (tempActual.descripcion != tempAnterior.descripcion) {
            this.capacidadesTecnicas[i].backColorDescripcion = this.backgroundActual;
            this.capacidadesTecnicas_anterior[indextempAnterior].backColorDescripcion = this.backgroundAnterior;
          }

          // Varificacion CANTIDAD
          if (tempActual.cantidad != tempAnterior.cantidad) {
            this.capacidadesTecnicas[i].backColorCantidad = this.backgroundActual;
            this.capacidadesTecnicas_anterior[indextempAnterior].backColorCantidad = this.backgroundAnterior;
          }
          //VERIFICAR DESCRIPCION SUB TIPO
          if (tempActual.descripcion_sub_tipo != tempAnterior.descripcion_sub_tipo) {
            this.capacidadesTecnicas[i].backColorDescripcionSubTipo = this.backgroundActual;
            this.capacidadesTecnicas_anterior[indextempAnterior].backColorDescripcionSubTipo = this.backgroundAnterior;
          }
        }
      }
      console.log(this.capacidadesTecnicas_anterior)
    } else if (option === "capacidadOperativa") {
      for (let i = 0; i < this.capacidadesOperativas.length; i++) {
        let tempActual = this.capacidadesOperativas[i];
        let tempAnterior = this.capacidadesOperativas_anterior.find(
          (element) =>
            element.formacion_empleado_id === tempActual.formacion_empleado_id
        );
        let indextempAnterior = this.capacidadesOperativas_anterior.findIndex(
          (element) => {
            return (
              element.formacion_empleado_id === tempActual.formacion_empleado_id
            );
          }
        );

        if(tempActual === undefined || tempAnterior === undefined){
          if(tempActual === undefined){
            this.capacidadesOperativas_anterior[indextempAnterior].backColorNumEmpleados = this.backgroundAnterior;
          } else if(tempAnterior === undefined){
            this.capacidadesOperativas[i].backColorNumEmpleados = this.backgroundActual;
          }
        } else{
          // Varificacion NUMERO EMPLEADOS
          if (tempActual.numero_empleados != tempAnterior.numero_empleados) {
            this.capacidadesOperativas[i].backColorNumEmpleados =
              this.backgroundActual;
            this.capacidadesOperativas_anterior[
              indextempAnterior
            ].backColorNumEmpleados = this.backgroundAnterior;
          }
        }
      }
    }
  }

  /*getDifferencesCapacidad(option){
    if(option === 'capacidadTecnica'){ // Capacidad Tencica
      for(let i=0; i < this.capacidadesTecnicas.length; i++){
        let tempActual = this.capacidadesTecnicas[i];
        let tempAnterior = this.capacidadesTecnicas_anterior.find(element => element.id_relacion === tempActual.id_relacion);
        let indextempAnterior = this.capacidadesTecnicas_anterior.findIndex(element => {
          return element.id_relacion === tempActual.id_relacion;
        });

        // Varificacion DESCRIPCION
        if(tempActual.descripcion != tempAnterior.descripcion){
          this.capacidadesTecnicas[i].backColorDescripcion = this.backgroundActual;
          this.capacidadesTecnicas_anterior[indextempAnterior].backColorDescripcion = this.backgroundAnterior;
        }

        // Varificacion CANTIDAD
        if(tempActual.cantidad != tempAnterior.cantidad){
          this.capacidadesTecnicas[i].backColorCantidad = this.backgroundActual;
          this.capacidadesTecnicas_anterior[indextempAnterior].backColorCantidad = this.backgroundAnterior;
        }
      }
    } else if(option === 'capacidadOperativa'){
      for(let i=0; i < this.capacidadesOperativas.length; i++){
        let tempActual = this.capacidadesOperativas[i];
        let tempAnterior = this.capacidadesOperativas_anterior.find(element => element.formacion_empleado_id === tempActual.formacion_empleado_id);
        let indextempAnterior = this.capacidadesOperativas_anterior.findIndex(element => {
          return element.formacion_empleado_id === tempActual.formacion_empleado_id;
        });

        // Varificacion NUMERO EMPLEADOS
        if(tempActual.numero_empleados != tempAnterior.numero_empleados){
          this.capacidadesOperativas[i].backColorNumEmpleados = this.backgroundActual;
          this.capacidadesOperativas_anterior[indextempAnterior].backColorNumEmpleados = this.backgroundAnterior;
        }
      }
    }
  }*/
}
